import { render, staticRenderFns } from "./CenterRightReview.vue?vue&type=template&id=5d2f0291&scoped=true"
import script from "./CenterRightReview.vue?vue&type=script&lang=js"
export * from "./CenterRightReview.vue?vue&type=script&lang=js"
import style0 from "./CenterRightReview.vue?vue&type=style&index=0&id=5d2f0291&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2f0291",
  null
  
)

export default component.exports